import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Typography from '../../../components/Basics/Typography'
import Spinner from '../../../components/Spinners/Spinner'
import ProjectCard from './ProjectCard'
import { onGetProjectsAsync } from './Project.slice'
import {
  filterProjectsByKind,
  PROJECT_KINDS,
} from './project.model'
import routes from '../../../config/settings/routes'
import {
  Container,
  EmptyState,
  ErrorState,
  Intro,
  Wrapper,
} from './Project.styles'

const SECTION_COPY = {
  [PROJECT_KINDS.PERSONAL]: {
    empty: 'No personal projects available.',
    id: 'projects',
    intro:
      'Products I build for real needs — from idea to a working application I can ship and improve over time.',
    title: 'Personal Projects',
  },
  [PROJECT_KINDS.PRACTICE]: {
    empty: 'No practice projects available.',
    id: 'practice',
    intro:
      'Small builds focused on learning a specific tool, pattern, or idea.',
    title: 'Learning & Practice',
  },
}

const Project = ({ kind = PROJECT_KINDS.PERSONAL }) => {
  const { error, loading, projects } = useSelector((state) => state.projects)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const section = SECTION_COPY[kind] || SECTION_COPY[PROJECT_KINDS.PERSONAL]
  const filteredProjects = filterProjectsByKind(projects, kind)

  const handleProjectClick = (project) => () => {
    navigate(routes.projectDetail.replace(':slug', project.slug))
  }

  useEffect(() => {
    dispatch(onGetProjectsAsync())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container id={section.id} $kind={kind}>
      <Typography variant="h1">{section.title}</Typography>
      <Intro>{section.intro}</Intro>

      {loading && filteredProjects.length === 0 && <Spinner />}
      {error && <ErrorState>Error loading projects.</ErrorState>}
      {!loading && !error && filteredProjects.length === 0 && (
        <EmptyState>{section.empty}</EmptyState>
      )}

      {filteredProjects.length > 0 && (
        <Wrapper>
          {filteredProjects.map((project) => (
            <ProjectCard
              key={project.id}
              onClick={handleProjectClick(project)}
              project={project}
            />
          ))}
        </Wrapper>
      )}
    </Container>
  )
}

Project.propTypes = {
  kind: PropTypes.oneOf([PROJECT_KINDS.PERSONAL, PROJECT_KINDS.PRACTICE]),
}

export default Project
